import { Destination } from '@rpldy/shared';

import fileService from './fileService';

/**
 * Submit a file to remote server
 * @param baseURL domain address
 */
export function postFile(baseURL: string): (sourceSystem: string) => Destination {
  return new fileService(baseURL).postFile;
}

/**
 * delete a file identifier from the remote server
 * @param baseURL domain address
 */
export function deleteFile(baseURL: string): (identifier: string) => Promise<any> {
  return new fileService(baseURL).deleteFile;
}
